import React from 'react';
export const EmotionalTransition: React.FC = () => {
  return <section className="py-20 px-4 bg-blue-900 text-white text-center" data-id="element-54">
      <div className="container mx-auto max-w-4xl space-y-8" data-id="element-55">
        <p className="text-xl md:text-2xl text-blue-100 leading-relaxed" data-id="element-56">
          Sé muy bien lo que es mirar el salón medio vacío en julio, después de
          haber dado todo durante el año. O tener que bajar los precios porque
          "total los demás cobran menos". Te entiendo, porque lo he visto
          muchísimas veces.
        </p>

        <p className="text-2xl md:text-3xl font-bold leading-relaxed" data-id="element-57">
          No es tu culpa si no te enseñaron a vender. A vos te enseñaron a
          bailar, a transmitir la tradición, a hacer una buena coreografía.
          Nadie te explicó nunca cómo llenar las clases, cómo hacer que te
          paguen lo que valés, o cómo lograr que tus alumnos se queden año tras
          año.
        </p>

        <p className="text-xl text-blue-200 leading-relaxed" data-id="element-58">
          Pero hay una buena noticia: todo esto se puede aprender. Y no hace
          falta convertirte en experto/a de marketing ni pasar horas frente a la
          computadora. Solo necesitás los contenidos correctos, las estrategias
          correctas, y alguien que te lo dé todo ya listo.
        </p>
      </div>
    </section>;
};